import '@sentinel/ui/tokens.css';
import '@sentinel/ui/fonts.css';
import '@sentinel/ui/base.css';
import '@sentinel/ui/styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';

const container = document.getElementById('root');
if (container === null) throw new Error('Root element not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
